require('./charts');

window.$ = window.jQuery = require('jquery');
window.Popper = require('@popperjs/core');
require('bootstrap');

const Axios = require('axios');
const Swal = require('sweetalert2');
window.Swal = Swal;

window.selfTest;

const checkIfSelected2IsSelected = ($el) => {
    const value = $el.val();
    if (value) {
        $el.next().find('.select2-selection').css('border', '1px solid #01d701')
    } else {
        $el.next().find('.select2-selection').css('border', '1px solid #aaa')
    }
}

const syncOrdinationQuestionOptions = (index) => {
    const $questions = $(`[ordination-question="${index}"]`);
    if (!$questions.length) {
        return;
    }

    $questions.find('option').attr('hidden', false);
    $questions.each(function () {
        const value = $(this).val();
        if (value) {
            $questions.find(`option[value="${value}"]`).attr('hidden', true);
            $(this).find(`option[value="${value}"]`).attr('hidden', false);
        }
    });
}

const getFlowBaseUrl = () => selfTest ? '/api/selftest' : '/quiz';
const getUuidQueryString = () => selfTest && window.selfTestUuid ? `?uuid=${window.selfTestUuid}` : '';

const goToStep = (stepPath) => {
    window.location.href = `${getFlowBaseUrl()}/${stepPath}${getUuidQueryString()}`;
}

const SESSION_HEARTBEAT_INTERVAL_MS = 10 * 60 * 1000;

// O uuid vem do meta renderizado a partir da sessão; a querystring é só fallback.
// Sem isso, o autoteste depende exclusivamente da sessão e não tem como se recuperar
// quando ela expira durante a leitura das etapas de validação.
const resolveSelfTestUuid = () => {
    const fromMeta = $('meta[name="selftest-uuid"]').attr('content');
    if (fromMeta && fromMeta.length === 36) {
        return fromMeta;
    }

    const uuid = new URLSearchParams(window.location.search || '').get('uuid');
    return uuid && uuid.length === 36 ? uuid : null;
}

const showLoading = () => {
    Swal.fire({
        text: "Por favor, espere.",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading()
        }
    });
}

const describeRequestError = (error) => {
    const status = error?.response?.status;

    if ([401, 403, 419].includes(status)) {
        return 'Sua sessão expirou. Recarregue a página para continuar de onde parou.';
    }

    return error?.response?.data?.message || 'Ocorreu um erro inesperado.';
}

const postJson = async (url, data) => {
    const response = await Axios.post(url, data);

    // Uma resposta 200 sem `success` significa falha silenciosa no servidor:
    // tratar como erro em vez de deixar a pessoa travada sem feedback.
    if (!response?.data?.success) {
        const error = new Error('Resposta inválida do servidor.');
        error.response = response;
        throw error;
    }

    return response.data;
}

const postStep = (stepPath, data) => postJson(`${getFlowBaseUrl()}/${stepPath}${getUuidQueryString()}`, data);

// As etapas de validação não fazem nenhuma requisição ao servidor: sem este ping,
// a sessão e o cookie CSRF expiram durante a leitura e o "Concluir" falha.
const startSessionHeartbeat = () => {
    if (!selfTest) {
        return;
    }

    setInterval(function () {
        Axios.get(`${getFlowBaseUrl()}/ping${getUuidQueryString()}`).catch(function () {});
    }, SESSION_HEARTBEAT_INTERVAL_MS);
}

$(function () {
    window.selfTest = window.location.pathname.includes('selftest') ? true : false;
    window.selfTestUuid = window.selfTest ? resolveSelfTestUuid() : null;

    startSessionHeartbeat();

    $('[select2]').select2({
        minimumResultsForSearch: Infinity,
        templateResult: function (option) {
            if (option.element && (option.element).hasAttribute('hidden')) {
                return null;
            }
            return option.text;
        }
    });

    $('[phone]').mask("99?9?9999?999999?9?9?9");

    $('[datepicker]').mask("99/99/9999");

    $('[quiz-step] [select2]').on('change', function () {
        checkIfSelected2IsSelected($(this));
    });

    $('.preliminary-result [quiz-step] [select2]').each(function () {
        checkIfSelected2IsSelected($(this));
    });

    $('[quiz-step] [ordination-question]').on('change', function () {
        const index = $(this).attr('ordination-question');
        syncOrdinationQuestionOptions(index);
    });

    const ordinationIndexes = [];
    $('[quiz-step] [ordination-question]').each(function () {
        const index = $(this).attr('ordination-question');
        if (ordinationIndexes.indexOf(index) === -1) {
            ordinationIndexes.push(index);
        }
    });
    ordinationIndexes.forEach((index) => syncOrdinationQuestionOptions(index));
});

window.goToPreviousStep = (currentStep) => {
    if (currentStep === 1) {
        if (selfTest) {
            goToStep('instructions');
            return;
        }

        window.location.href = '/quiz';
        return;
    }

    const previousSteps = {
        2: 'stepone',
        3: 'steptwo',
        4: 'stepthree',
        5: 'stepfour',
    };

    const previousStepPath = previousSteps[currentStep];
    if (!previousStepPath) {
        return;
    }

    goToStep(previousStepPath);
}

const extractStepOneData = () => {
    const data = [];

    $('[agreement-question]').each(function () {
        const $answer = $(this);
        const index = $answer.attr('agreement-question');

        data[index] = $answer.val();
    });

    return !data.includes('') ? data : false;
}

window.submitStepOne = async () => {
    const data = extractStepOneData();

    if (!data) {
        toastr.error('Por favor, preencha todos os campos.')
        return false;
    }

    showLoading();

    try {
        await postStep('stepone', data);
        Swal.close();
        goToStep('steptwo');
    } catch (error) {
        Swal.close();
        toastr.error(describeRequestError(error));
    }
}

const extractStepTwoData = () => {
    const data = [];

    $('[frequency-question]').each(function () {
        const $answer = $(this);
        const index = $answer.attr('frequency-question');

        data[index] = $answer.val();
    });

    return !data.includes('') ? data : false;
}

window.submitStepTwo = async () => {
    const data = extractStepTwoData();

    if (!data) {
        toastr.error('Por favor, preencha todos os campos.')
        return false;
    }

    showLoading();

    try {
        await postStep('steptwo', data);
        Swal.close();
        goToStep('stepthree');
    } catch (error) {
        Swal.close();
        toastr.error(describeRequestError(error));
    }
}

const extractStepThreeData = () => {
    const data = {};

    $('[block]').each(function () {
        const $block = $(this);

        const blockName = $block.attr('block');

        data[blockName] = []

        $block.find('[comparison-question]:checked').each(function () {
            data[blockName].push($(this).val())
        })
    });

    const values = Object.values(data);
    for (let i = 0; i < values.length; i++) {
        if (values[i].length < 8) {
            return false;
        }
    }

    return data;
}

window.submitStepThree = async () => {
    const data = extractStepThreeData();

    if (!data) {
        toastr.error('Por favor, preencha todos os campos.')
        return false;
    }

    showLoading();

    try {
        await postStep('stepthree', data);
        Swal.close();
        goToStep('stepfour');
    } catch (error) {
        Swal.close();
        toastr.error(describeRequestError(error));
    }
}

const hasDuplicates = (arr) => arr.some((e, i, arr) => arr.indexOf(e) !== i);

const extractStepFourData = () => {
    const data = [];

    $('[ordination-question]').each(function () {
        const $answer = $(this);
        const index = $answer.attr('ordination-question');

        if (!data[index]) {
            data[index] = [];
        }

        data[index].push($answer.val());
    });

    let answer;
    for (let i = 0; i < data.length; i++) {
        answer = data[i];
        if (answer.includes('') || hasDuplicates(answer)) {
            return false;
        }
    }

    return data;
}

window.submitStepFour = async () => {
    const data = extractStepFourData();

    if (!data) {
        toastr.error('Preencha todos os campos e verifique se a ordem das questões é válida.')
        return false;
    }

    showLoading();

    try {
        await postStep('stepfour', data);
        Swal.close();
        goToStep('stepfive');
    } catch (error) {
        Swal.close();
        toastr.error(describeRequestError(error));
    }
}

const extractStepFiveData = () => {
    const data = {};

    $('[block]').each(function () {
        const $block = $(this);

        const blockName = $block.attr('block');

        data[blockName] = []

        $block.find('[identification-question]:checked').each(function () {
            data[blockName].push($(this).val())
        })
    });

    const values = Object.values(data);
    for (let i = 0; i < values.length; i++) {
        if (values[i].length < 3) {
            return false;
        }
    }

    return data;
}

window.submitStepFive = async () => {
    const data = extractStepFiveData();

    if (!data) {
        toastr.error('Por favor, preencha todos os campos.')
        return false;
    }

    showLoading();

    try {
        const result = await postStep('stepfive', data);
        Swal.close();

        window.location.href = `${getFlowBaseUrl()}/preliminaryresult`
            + (selfTest ? getUuidQueryString() : `/${result.preliminaryResultId}`);
    } catch (error) {
        Swal.close();
        toastr.error(describeRequestError(error));
    }
}

const extractPreliminaryResultsData = () => {
    let success = true;
    const personalityType = $('[name="personality_type"]').val();
    const triad = $('[name="triad"]').val();
    const instinctiveSequence = $('[name="instinctive_sequence"]').val();
    const personalitySubtype = $('[name="personality_subtype"]').val();

    if (!personalityType) {
        toastr.error('Informe o tipo de personalidade.')
        success = false
    }

    if (!triad) {
        toastr.error('Informe a tríade em que se vê mais.')
        success = false
    }

    if (!instinctiveSequence) {
        toastr.error('Informe a sequência instintiva.')
        success = false
    }

    if (!personalitySubtype) {
        toastr.error('Informe o subtipo de personalidade.')
        success = false
    }

    if (success) {
        return {
            personalityType,
            triad,
            instinctiveSequence,
            personalitySubtype,
        };
    }

    return false;
}

window.submitPreliminaryResults = async () => {
    const data = extractPreliminaryResultsData();

    if (!data) {
        return false;
    }

    showLoading();

    const url = `${getFlowBaseUrl()}/preliminaryresults`
        + (selfTest ? getUuidQueryString() : `/${preliminaryResultId}`);

    try {
        const result = await postJson(url, data);
        Swal.close();

        window.location.href = `${getFlowBaseUrl()}/finalresults`
            + (selfTest ? getUuidQueryString() : `/${result.finalResultId}`);
    } catch (error) {
        Swal.close();
        toastr.error(describeRequestError(error));
    }
}
